import { render, staticRenderFns } from "./ProductOverviewWorkpostPage.vue?vue&type=template&id=7a3bd8ca"
import script from "./ProductOverviewWorkpostPage.vue?vue&type=script&lang=js"
export * from "./ProductOverviewWorkpostPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports